export const setCookie = (name, value, days) => {
  if (days > 0) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires}; path=/`;
  } else {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
  }
};

export const getCookie = (name) => {
  const cookieName = name + '=';
  return document.cookie.split('; ').reduce((r, v) => {
    const idx = v.indexOf('=');
    if (idx === -1) return r;
    const key = v.substring(0, idx);
    if (key === cookieName.slice(0, -1)) {
      return decodeURIComponent(v.substring(idx + 1));
    }
    return r;
  }, '');
};

export const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
};
